import { render, staticRenderFns } from "./EmployeesSituationByAge.vue?vue&type=template&id=61025076&scoped=true&"
import script from "./EmployeesSituationByAge.vue?vue&type=script&lang=js&"
export * from "./EmployeesSituationByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61025076",
  null
  
)

export default component.exports